var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75 37.5C75 58.2107 58.2107 75 37.5 75C16.7893 75 0 58.2107 0 37.5C0 16.7893 16.7893 0 37.5 0C58.2107 0 75 16.7893 75 37.5ZM33.2224 47.102C32.8786 47.4228 32.5303 47.7299 32.1819 48.0187C28.9629 50.8724 25.5185 53.4614 21.8824 55.7603H12C12.2281 52.8362 12.6879 49.9349 13.3751 47.0837L33.2224 47.102ZM55.1336 48.092L61.5003 19.5L37.6286 36.3169L42.4414 39.5575C40.1542 42.1105 37.789 44.4939 35.3871 46.694C35.2452 46.8268 35.1028 46.96 34.9563 47.0882C34.774 47.2486 34.5917 47.4103 34.4087 47.5727C34.2466 47.7164 34.084 47.8607 33.9204 48.0049C30.7013 50.8587 27.2569 53.4476 23.6208 55.7465H34.8692C37.1894 55.7547 39.4355 54.9301 41.1992 53.4227C41.2083 53.4244 41.2176 53.4244 41.2267 53.4227C42.9746 51.9284 44.6798 50.3379 46.3421 48.6512C47.6118 47.377 48.8494 46.0523 50.0686 44.6773L54.8311 47.8858L55.1336 48.092Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivity);
export default __webpack_public_path__ + "static/media/activity.791872633cf95dce516104e34e343c99.svg";
export { ForwardRef as ReactComponent };